import { DATE_LOCALE } from './dateLocale';

export const convertToReadableDate = (date: string): string => {
  if (!date) {
    return '';
  }
  return new Date(date).toLocaleDateString(DATE_LOCALE);
};
